/**
 * One place for turning a unix timestamp into text.
 *
 * Everything here renders in the VIEWER'S LOCAL timezone. That is not
 * cosmetic: the date-range filters (AuditLog, FlashHistory, DiskTimeline) take
 * their day boundaries from dayjs `startOf('day')`, which is local. When the
 * tables printed UTC instead, a Moscow user saw "2026-07-20 23:03" on a row
 * that the "20 July" filter refused to match — the event was already 21 July
 * locally. Format and filter have to agree, and the filter is the one the user
 * picks in a calendar, so local wins.
 */

const p2 = (n: number): string => String(n).padStart(2, '0');

/** `YYYY-MM-DD HH:MM:SS`, local. */
export function fmtDateTime(unix: number): string {
  const d = new Date(unix * 1000);
  return (
    `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())} ` +
    `${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}`
  );
}

/** `YYYY-MM-DD HH:MM`, local — for places where seconds are noise. */
export function fmtDateTimeMin(unix: number): string {
  return fmtDateTime(unix).substring(0, 16);
}

/** `YYYY-MM-DD`, local. */
export function fmtDate(unix: number): string {
  return fmtDateTime(unix).substring(0, 10);
}
